import {useQuery} from '@tanstack/react-query'
import {getUnreadMessageCount} from '../services/chat.http'
import {QUERY_KEYS} from './keys'
import {useMe} from '@/features/authentication/queries/useMe'
import {getCorrectUserId} from '@/utilities/helpers'
import {UserV3} from '@/features/authentication/types'

interface UseGetUnreadMessageCountOptions {
    enabled?: boolean
}

export const useGetUnreadMessageCountV3 = ({enabled = true}: UseGetUnreadMessageCountOptions = {}) => {
    const {data: user, loggedIn} = useMe()

    const representedCreatorId: string | number | undefined = getCorrectUserId(user as UserV3)
    return useQuery<{unreadMessagesCount: number}, Error>({
        queryKey: [QUERY_KEYS.fetchUnreadMessageCountV3, representedCreatorId],
        queryFn: () => getUnreadMessageCount(representedCreatorId),
        enabled: enabled && !!loggedIn
    })
}
